<template>
  <page-wrapper :title="title">
    <loading-overlay :active="isLoading" />
    <div class="header">
      <sc-button :route="{ name: 'PopupBannerCreatePage' }" variant="primary"
        >เพิ่ม Popup Banner</sc-button
      >
    </div>
    <div v-for="item in list" :key="item.id" class="popup-banner-row">
      <div class="image-container">
        <img :src="item.imageUrl" class="image img-fluid" />
      </div>
      <div class="detail">
        <router-link :to="item.route" class="title">
          {{ item.title }}
        </router-link>
        <p v-if="item.subtitle" class="subtitle">{{ item.subtitle }}</p>
        <div v-if="item.note" class="note text-danger">{{ item.note }}</div>
        <div class="subtitle">
          <span class="label">ระยะเวลาแสดงผล</span>
          <div class="value">{{ item.publishDate }}</div>
        </div>
        <div class="subtitle">
          <span class="label">สร้างโดย</span>
          <div class="value">{{ item.createdBy }}</div>
        </div>
        <div class="subtitle">
          <div class="label">สร้างเมื่อ</div>
          <div class="value">{{ item.createdAt }}</div>
        </div>
      </div>
    </div>
    <div class="wrapper text-end padding-adjust">
      <el-pagination
        :total="total"
        :page-size="10"
        :current-page="queryParams.page"
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </page-wrapper>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies"
import LoadingOverlay from "@/lib/components/LoadingOverlay"
import PageWrapper from "@/lib/components/PageWrapper"
import ScButton from "@/lib/components/ScButton"
import { toLocaleTH } from "@/lib/dateTime"
import { Pagination } from "element-ui"
import { DateTime } from "luxon"

export default {
  components: {
    PageWrapper,
    ScButton,
    LoadingOverlay,
    "el-pagination": Pagination
  },
  data() {
    const title = "รายการ Popup Banner"
    const total = 0
    const list = []

    return {
      title,
      list,
      total,
      isLoading: false
    };
  },
  computed: {
    queryParams() {
      return {
        page: parseInt(this.$route.query.page, 10) || 1,
      }
    },
  },
  watch: {
    "$route.query": async function routeQueryWatcher() {
      await this.setupData()
    },
  },
  created() {
    this.setup()
  },
  methods: {
    setup() {
      this.setupData()
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page },
      }

      this.$router.replace(route)
    },
    async setupData() {
      this.isLoading = true;
      const { popup_banners: popupBanners, count } = await this.fetchData();

      this.list = popupBanners.map((item) => {
        const publishDate = `${this.formatDate(
          item.published_start_at,
        )} - ${this.formatDate(item.published_end_at)}`
        const createdBy = `${item.admin.first_name} ${item.admin.last_name}`
        const route = {
          name: "PopupBannerDetailPage",
          params: { id: item.id },
        }
        const subtitle = this.getListItemSubtitle(item)
        const createdAt = this.formatDate(item.created_at)
        this.total = count

        return {
          id: item.id,
          title: item.title,
          subtitle,
          publishDate,
          createdBy,
          route,
          note: item.delete_at ? "ถูกลบ" : null,
          createdAt,
          imageUrl: item.image_url
        };
      });
      this.isLoading = false;
    },
    async fetchData() {
      const response =
        await baanRueJaiClient.admin.communications.popupBanners.list(
          this.queryParams,
        )

      return response.data.result
    },
    getListItemSubtitle(item) {
      if (item.subtitle) {
        return item.subtitle
      }

      if (item.start_at && item.end_at) {
        return `${this.formatDate(item.start_at)} - ${this.formatDate(item.end_at)}`
      }

      return undefined
    },
    formatDate(date) {
      const format = "dd MMMM yyyy"

      return toLocaleTH(DateTime.fromISO(date)).toFormat(format)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  padding: 30px;
}

.popup-banner-row {
  padding: 15px 30px;
  display: grid;
  grid-template-columns: 150px 1fr;
  grid-gap: 30px;

  .title {
    font-size: 1.2rem;
    margin-bottom: 5px;
  }

  border-bottom: $border;
}

.subtitle {
  margin-bottom: 10px;
}

.label {
  color: #777;
  font-size: 0.9rem;
}

.value {
  font-size: 1rem;
}

.note {
  font-size: 0.8rem;
}

.padding-adjust {
  padding: 10px 0;
}
</style>
